import * as types from "../actions/Types";

const initialState = {};

export default function adminNestReducer(state = initialState, action) {
  switch (action.type) {
    case types.CLEAR_ACCOUNT_DATA:
    case types.RESET_STATE:
      return initialState;
    default:
      return state;
  }
}
